module.exports = __webpack_public_path__ + "img/logo-vrjmof2023.3f18b81a.svg";